<template lang="pug">
.transparent-navbar
  .navbar
    .navbar-inner.sliding
      f7-nav-left(class="nav-left")
        f7-link.back-page(back)
          svg-icon(icon="back")

      f7-nav-title(v-if="title")

      f7-nav-right(class="nav-right")
        slot(name="right")
</template>

<style lang="scss" scoped>
.transparent-navbar {
  position: absolute;
  width: 100%;

  .navbar {
    background-color: transparent;

    &::after {
      background: none !important;
    }

    .navbar-inner {
      overflow: visible;
      justify-content: space-between;
      padding: 0 8px;
    }
  }

  .left {
    margin-left: 4pt;
    margin-top: 16pt;
  }

  .right {
    margin: 16pt 4pt 0 4pt;
  }
}

a.back-page.link {
  border-radius: 50%;
  background-color: rgba(22, 23, 26, 0.2);
  text-align: center;

  @media (max-width: 768px) {
    width: 50px;
    min-width: 50px !important;
    height: 50px;
    line-height: 40px;
  }
  @media (min-width: 768px) {
    width: 64px;
    display: inline-block;
  }

  .svg-icon {
    margin-left: auto;
    margin-right: auto;
    width: 24px;
    height: 40px;
    font-weight: bold;
  }
}
</style>

<script>
export default {
  props: {
    title: String,
  },
}
</script>
